import axios from "axios";

const state = () => ({
  courses: [],
  courseNames: [],
  current_page: 1,
  last_page: 1,
  per_page: 5,
  total: 0,
  errors: [],
  loading: false,
  isDeleted: false,
  isCreated: false,
  message: "",
});

const mutations = {
  SET_COURSE_NAMES(state, courseNames) {
    state.courseNames = courseNames;
  },
  SET_COURSES(state, courses) {
    state.courses = courses;
  },
  SET_CURRENT_PAGE(state, page) {
    state.current_page = page;
  },
  SET_LAST_PAGE(state, page) {
    state.last_page = page;
  },
  SET_PER_PAGE(state, per_page) {
    state.per_page = per_page;
  },
  SET_TOTAL(state, total) {
    state.total = total;
  },
  SET_ERRORS(state, errors) {
    state.errors = errors;
  },
  SET_LOADING(state) {
    state.loading = true;
  },
  CLEAR_LOADING(state) {
    state.loading = false;
  },
  SET_IS_DELETED(state, isDeleted) {
    state.isDeleted = isDeleted;
  },
  SET_IS_CREATED(state, isCreated) {
    state.isCreated = isCreated;
  },
  SET_MESSAGE(state, message) {
    state.message = message;
  },
};

const getters = {
  getCourseNames: (state) => {
    return state.courseNames;
  },
  getCourses: (state) => {
    return state.courses;
  },
  getCurrentPage: (state) => {
    return state.current_page;
  },
  getLastPage: (state) => {
    return state.last_page;
  },
  getPerPage: (state) => {
    return state.per_page;
  },
  getTotal: (state) => {
    return state.total;
  },
  getErrors: (state) => {
    return state.errors;
  },
  getIsDeleted: (state) => {
    return state.isDeleted;
  },
  getIsCreated: (state) => {
    return state.isCreated;
  },
  isLoading: (state) => {
    return state.loading;
  },
};

const actions = {
  async fetchCourseNames({ commit }, payload) {
    commit("SET_LOADING");

    // /api/tm/courses/courses-all?search=ste
    const url =
      process.env.VUE_APP_API_URL +
      "/tm/courses/courses-all" +
      queryBuilder(payload);

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      commit("SET_COURSE_NAMES", response.data.data);
      commit("SET_ERRORS", []);
      commit("CLEAR_LOADING");
    } catch (error) {
      console.log(error);
      commit("CLEAR_LOADING");
      commit(
        "SET_ERRORS",
        error.response?.data?.message || "Fetch Courses failed"
      );
    }
  },
  async fetchCourses({ commit }, payload) {
    commit("SET_LOADING");
    // /api/tm/courses?page=1&per_page=3&sort_by=id&sort_order=desc&search=ste
    const url =
      process.env.VUE_APP_API_URL + "/tm/courses" + queryBuilder(payload);

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      commit("SET_COURSES", response.data.data);
      commit("SET_CURRENT_PAGE", response.data.current_page);
      commit("SET_LAST_PAGE", response.data.last_page);
      commit("SET_PER_PAGE", response.data.per_page);
      commit("SET_TOTAL", response.data.total);
      commit("SET_ERRORS", []);
      commit("CLEAR_LOADING");
    } catch (error) {
      console.log(error);
      commit("CLEAR_LOADING");
      commit(
        "SET_ERRORS",
        error.response?.data?.message || "Fetch Courses failed"
      );
    }
  },
  async saveCourse({ commit }, payload) {
    commit("SET_LOADING");
    const url = process.env.VUE_APP_API_URL + "/tm/courses";
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.post(url, payload, config);
      commit("SET_ERRORS", []);
      commit("SET_IS_CREATED", true);
      commit("SET_MESSAGE", "Course created successfully");
      commit("CLEAR_LOADING");
      return response;
    } catch (error) {
      console.log(error);
      commit("CLEAR_LOADING");
      commit("SET_IS_CREATED", false);
      commit("SET_MESSAGE", "");
      commit("SET_ERRORS", error.response?.data?.error || "Save Course failed");
      throw error.response?.data?.error || "Save Course failed";
    }
  },
  async deleteCourses({ commit }, payload) {
    commit("SET_LOADING");
    const url = process.env.VUE_APP_API_URL + "/tm/courses/";
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
      data: {
        ids: payload,
      },
    };
    console.log("config", config);
    try {
      const response = await axios.delete(url, config);
      commit("CLEAR_LOADING");
      commit("SET_MESSAGE", response.data.message);
      commit("SET_IS_DELETED", true);
    } catch (error) {
      console.log(error);
      commit("CLEAR_LOADING");
      commit("SET_IS_DELETED", false);
      commit(
        "SET_ERRORS",
        error.response?.data?.message || "Delete Courses failed"
      );
      throw error.response?.data?.message || "Delete Courses failed";
    }
  },
  clearIsDeleted({ commit }) {
    commit("SET_IS_DELETED", false);
  },
  clearIsCreated({ commit }) {
    commit("SET_IS_CREATED", false);
  },
};

const queryBuilder = (payload) => {
  if (!payload) {
    return "";
  }
  let query = [];
  if (payload.page) {
    query.push("page=" + payload.page);
  }

  if (payload.pageSize) {
    query.push("per_page=" + payload.pageSize);
  }

  if (payload.searchTerm) {
    query.push("search=" + payload.searchTerm);
  }

  if (payload.primary) {
    query.push("primary=" + payload.primary);
  }

  if (payload.sortOrder) {
    query.push("sort_by=" + payload.sortOrder.key);
    query.push("sort_order=" + payload.sortOrder.direction);
  }

  if (query.length > 0) {
    query = "?" + query.join("&");
    return query;
  }

  return "";
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
